import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';

@Component({
    selector: 'not-authorized',
    templateUrl: './not-authorized.component.html',
    styleUrls: ['./not-authorized.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NotAuthorizedComponent implements OnInit {
  /** Coming from the message center: offer a logout, to sign in with an admin account (as in the ESS dashboard) */
  public isMessageCenterPath = false;
  private returnUrl: string;

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'];
    this.isMessageCenterPath = /message-center/.test(this.returnUrl ?? '');
  }

  public goHome(): void {
    this.router.navigateByUrl(this.authService.homeUrl(AuthService.appForUrl(this.returnUrl ?? '/')));
  }

  public logout(): void {
    this.authService.clearSession();
    this.router.navigate([this.authService.loginUrl('ess')], { queryParams: { returnUrl: this.returnUrl } });
  }
}
